import type { ApolloError } from '@apollo/client'
import type { FC } from 'react'
import { useState } from 'react'

import ExpandableCard from '@/components/ExpandableCard'
import Pill from '@/components/Pill'
import { VerifAIFlags } from '@/components/VerifAIFlags'
import type { FlagFeedbackPayload } from '@/lib/apollo/mutation/patchFlagFeedback/mutation'
import type { VerifAIFlag } from '@/lib/apollo/query/getVerifAIFlags/query'

export interface Props {
  submitFlagFeedback: (payload: FlagFeedbackPayload) => Promise<void>
  loadingFlagFeedback?: boolean
  flagFeedbackError?: ApolloError
  flags: VerifAIFlag[]
  userId: string
  subjectId: string
}

const VerifAICard: FC<Props> = ({
  submitFlagFeedback,
  flags,
  userId,
  subjectId,
  loadingFlagFeedback,
  flagFeedbackError,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <ExpandableCard
      label="VerifAI Advisories"
      icon="ai"
      isExpanded={isExpanded}
      handleExpand={() => setIsExpanded(!isExpanded)}
      expandedContent={
        <VerifAIFlags
          submitFlagFeedback={submitFlagFeedback}
          flags={flags}
          userId={userId}
          subjectId={subjectId}
          loadingFlagFeedback={loadingFlagFeedback}
          flagFeedbackError={flagFeedbackError}
        />
      }
      actionButton={<Pill type="info">{flags.length}</Pill>}
    />
  )
}

export default VerifAICard
